import { PAGE_DATA, SITE_LOCALE } from 'app-constants';

import { getPageData as getData } from 'stile-shared/src/utils/getPageData';

export const getPageData = getData(PAGE_DATA, SITE_LOCALE);
